import React, { useEffect } from "react";
import logo from "../assets/images/BUZD-Logo-Icon-Black.png";
import { useDimensions } from "../hooks";

function Landing() {
  const { height } = useDimensions();

  useEffect(() => {
    return () => {};
  }, []);

  // const text = "If you don't have the Buzd app,\nDownload it here silly goose!";

  return (
    <div
      style={{
        display: "flex",
        height: height,
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#feda30",
      }}
    >
      {/* LOGO */}
      <img
        src={logo}
        alt="Buzd Logo"
        width={height * 0.5}
        height={height * 0.5}
      />
    </div>
  );
}

export default Landing;
